import { ConvexError } from "convex/values";

/** User-facing text for an error thrown by a Convex function or anything else. */
export function errorMessage(error: unknown): string {
  if (error instanceof ConvexError) {
    const data = error.data as unknown;
    if (typeof data === "string") return data;
    if (data && typeof data === "object" && "message" in data && typeof (data as { message: unknown }).message === "string") {
      return (data as { message: string }).message;
    }
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}
